export default __webpack_public_path__ + "static/media/Ro-system.ae7ceae4.jpg";